import { isNil } from "@/common/helpers/lang";

import { env } from "../env/client.mjs";
import { canUseDOM } from "./can-use-dom";

export const getServerSideURL = (pathname?: string) => {
  let url = env.NEXT_PUBLIC_BASE_URL;

  if (isNil(url)) {
    url = "http://localhost:3000";
  }

  if (pathname) {
    url = `${url}${pathname}`;
  }

  return url;
};

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol;
    const domain = window.location.hostname;
    const port = window.location.port;
    const portString = port ? `:${port}` : "";

    return `${protocol}//${domain}${portString}`;
  }

  return env.NEXT_PUBLIC_BASE_URL;
};
